import React from "react";
import Button from "./Button";
import { useFormCtx } from "./../FormContext";
import * as Const from "./../_Const";

const NotFoundSection = ({ className, title, subtitle, action = "", showButton = false }) => {
  const { navigateHome } = useFormCtx();
  const isTerminal = Const.isTerminal();
  const titleCss = isTerminal ? "text-4xl" : "text-2xl";
  const subTitleCss = isTerminal ? "text-2xl mt-4" : "text-lg mt-0";

  return (
    <div className={className}>
      <p className={`mt-12 ${titleCss} font-black text-accent-dark dark:text-accent`}>{title}</p>
      <p className={`mt-12 ${subTitleCss}  font-light text-secondary`}>
        {subtitle} <span className="uppercase font-medium italic">{action}</span>
      </p>
      <div className="mt-6 flex place-content-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="145.841" height="145.841" viewBox="0 0 145.841 145.841">
          <g id="Group_24" data-name="Group 24" transform="translate(-149 -477.489)">
            <path
              id="Icon_material-search"
              data-name="Icon material-search"
              d="M111.732,99.224h-6.587l-2.335-2.251a54.282,54.282,0,1,0-5.837,5.837l2.251,2.335v6.587l41.693,41.609,12.424-12.424Zm-50.031,0A37.523,37.523,0,1,1,99.224,61.7,37.473,37.473,0,0,1,61.7,99.224Z"
              transform="translate(141.5 469.989)"
              fill="#bee4e0"
            />
            <g id="Icon_ionic-md-sad" data-name="Icon ionic-md-sad" transform="translate(171.492 500.194)">
              <path
                id="Path_14"
                data-name="Path 14"
                d="M30.232,33.75A13.51,13.51,0,0,0,18.023,41.4H42.442A13.51,13.51,0,0,0,30.232,33.75Z"
                transform="translate(1.436 1.978)"
                fill="#bee4e0"
              />
              <path
                id="Path_15"
                data-name="Path 15"
                d="M31.668,5.625a25.9,25.9,0,1,0,26.043,25.9A25.964,25.964,0,0,0,31.668,5.625Zm0,46.618A20.719,20.719,0,1,1,52.5,31.524,20.839,20.839,0,0,1,31.668,52.243Z"
                transform="translate(0 0)"
                fill="#bee4e0"
              />
              <path
                id="Path_16"
                data-name="Path 16"
                d="M38.6,27.7a3.727,3.727,0,1,0-3.727-3.727A3.66,3.66,0,0,0,38.6,27.7Z"
                transform="translate(2.255 1.025)"
                fill="#bee4e0"
              />
              <path
                id="Path_17"
                data-name="Path 17"
                d="M21.54,27.7a3.727,3.727,0,1,0-3.727-3.727A3.66,3.66,0,0,0,21.54,27.7Z"
                transform="translate(0.94 1.025)"
                fill="#bee4e0"
              />
            </g>
          </g>
        </svg>
      </div>
      {showButton && (
        <div className="mt-12 mb-4">
          <div className="justify-self-center">
            <Button type="primary" title="Na hlavní obrazovku" showIcon={false} onClick={navigateHome} />
          </div>
        </div>
      )}
    </div>
  );
};

export default NotFoundSection;
